import { apiService } from './apiService';
import { API_ENDPOINTS } from '../constants/apiConstants';

export const reportService = {
  // Create a new report
  createReport: async (reportData) => {
    try {
      const response = await apiService.post(API_ENDPOINTS.REPORT, {
        name: reportData.name,
        type: reportData.type,
        sub_title: reportData.sub_title,
        description: reportData.description,
        prompt: reportData.prompt
      });

      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Report created successfully'
      };
    } catch (error) {
      console.error('Create report error:', error);
      
      let errorMessage = 'Failed to create report. Please try again.';
      
      if (error.response) {
        // Check for 'detail' field (FastAPI style) or 'message' field
        const apiError = error.response.data?.detail || error.response.data?.message;
        errorMessage = apiError || errorMessage;
      } else if (error.request) {
        errorMessage = 'Network error. Please check your internet connection.';
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  },

  // Get all reports
  getReports: async (params = {}) => {
    try {
      const config = Object.keys(params).length ? { params } : {};
      const response = await apiService.get(API_ENDPOINTS.REPORT, config);

      return {
        success: true,
        data: response.data.result || response.data,
        message: response.data?.message || 'Reports fetched successfully'
      };
    } catch (error) {
      console.error('Get reports error:', error);
      
      let errorMessage = 'Failed to fetch reports. Please try again.';
      
      if (error.response) {
        // Check for 'detail' field (FastAPI style) or 'message' field
        const apiError = error.response.data?.detail || error.response.data?.message;
        errorMessage = apiError || errorMessage;
      } else if (error.request) {
        errorMessage = 'Network error. Please check your internet connection.';
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  },

  // Get report by ID
  getReportById: async (reportId) => {
    try {
      const response = await apiService.get(`${API_ENDPOINTS.REPORT}${reportId}`);

      return {
        success: true,
        data: response.data.result || response.data,
        message: response.data?.message || 'Report fetched successfully'
      };
    } catch (error) {
      console.error('Get report by ID error:', error);
      
      let errorMessage = 'Failed to fetch report. Please try again.';
      
      if (error.response) {
        // Check for 'detail' field (FastAPI style) or 'message' field
        const apiError = error.response.data?.detail || error.response.data?.message;
        errorMessage = apiError || errorMessage;
      } else if (error.request) {
        errorMessage = 'Network error. Please check your internet connection.';
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  },

  // Update a report
  updateReport: async (reportId, reportData) => {
    try {
      const response = await apiService.patch(`${API_ENDPOINTS.REPORT}${reportId}`, {
        name: reportData.name,
        type: reportData.type,
        sub_title: reportData.sub_title,
        description: reportData.description,
        prompt: reportData.prompt
      });

      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Report updated successfully'
      };
    } catch (error) {
      console.error('Update report error:', error);
      
      let errorMessage = 'Failed to update report. Please try again.';
      
      if (error.response) {
        // Check for 'detail' field (FastAPI style) or 'message' field
        const apiError = error.response.data?.detail || error.response.data?.message;
        errorMessage = apiError || errorMessage;
      } else if (error.request) {
        errorMessage = 'Network error. Please check your internet connection.';
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  },

  // Delete a report
  deleteReport: async (reportId) => {
    try {
      const response = await apiService.delete(`${API_ENDPOINTS.REPORT}${reportId}`);

      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Report deleted successfully'
      };
    } catch (error) {
      console.error('Delete report error:', error);
      
      let errorMessage = 'Failed to delete report. Please try again.';
      
      if (error.response) {
        // Check for 'detail' field (FastAPI style) or 'message' field
        const apiError = error.response.data?.detail || error.response.data?.message;
        errorMessage = apiError || errorMessage;
      } else if (error.request) {
        errorMessage = 'Network error. Please check your internet connection.';
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  }
};